import { Radio, Users, BookOpen, Bot } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const features = [
  { icon: Radio, title: "Live Response", desc: "Go live in the app the moment something serious is happening — an AI companion starts recording automatically and alerts the volunteer network by location." },
  { icon: Users, title: "Witness Network", desc: "Other members can watch remotely or show up in person — registered or not. The app connects people by location." },
  { icon: BookOpen, title: "In-the-Moment Guidance", desc: "Built-in SOPs — what to do during an event, and what to do right after." },
  { icon: Bot, title: "AI Advisor (Future)", desc: "An embedded AI companion to guide people through an event in real time and coordinate the witness response, once funding allows." },
];

export default function Bern() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
      <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide bg-red-50 text-red-700 border border-red-200 mb-6">
        Coming Soon — In Development
      </span>
      <h1 className="font-display font-extrabold uppercase text-3xl md:text-5xl text-zinc-950 tracking-tight mb-5">
        BERN <span className="text-[#1E3A6E]">Bias Emergency Response Network</span>
      </h1>
      <p className="text-zinc-600 leading-relaxed max-w-2xl mx-auto mb-4">
        BERN is our answer to the violent, emergency track of bias. It's the deeper long-term vision we're
        building toward: an AI companion that starts recording, alerts our volunteer network by location, and
        can go live so people can join as witnesses — remotely or in person, registered or not.
      </p>
      <p className="text-zinc-500 text-sm max-w-2xl mx-auto mb-14">
        Live streaming and location-based witness connection require a full legal and safety review first —
        liability, verification, safety planning — before this goes live. We're doing that work now.
      </p>

      <div className="grid sm:grid-cols-2 gap-6 text-left mb-14">
        {features.map((f) => (
          <div key={f.title} className="bg-white border border-zinc-200 rounded-sm p-6">
            <div className="h-11 w-11 rounded-full border border-[#4FD1C5]/40 flex items-center justify-center mb-4">
              <f.icon className="h-5 w-5 text-[#1E3A6E]" />
            </div>
            <h3 className="font-display font-bold text-zinc-950 mb-2">{f.title}</h3>
            <p className="text-zinc-500 text-sm leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>

      <div className="bg-[#EAF3F7] border border-zinc-200 rounded-sm p-8">
        <h3 className="font-display font-bold uppercase text-xl text-zinc-950 mb-3">Need help right now?</h3>
        <p className="text-zinc-600 text-sm mb-5">Read our During and After guidelines — they're live today.</p>
        <Link to="/guidelines"><Button className="bg-zinc-950 text-white rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">View Guidelines</Button></Link>
      </div>
    </div>
  );
}
